import type { JobAdsState, JobAdsStateResponse } from "./types"
import type { NextRequest } from "@/modules/fetch/types"

import { keysToCamelCase } from "@/modules/apiRequests/dataStructure"
import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

import { JOB_ADS_STATE_ENDPOINT } from "./constants"

export const getJobAdsState = async (ids: string[], nextRequest?: NextRequest): Promise<JobAdsState> =>
  fetcher(JOB_ADS_STATE_ENDPOINT, {
    nextRequest,
    requestInit: {
      body: JSON.stringify({ post_ids: ids }),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
  })
    .then(getResultFromResponse<JobAdsStateResponse>({ transformResult: keysToCamelCase<JobAdsStateResponse> }))
    .then(({ posts }) => posts)
    .catch(handleFetchError(JOB_ADS_STATE_ENDPOINT, { ids }))
